import { Label } from '../Label/Label';
import { Radio } from '../Radio';
import clsx from 'clsx';
import styles from './RadioGroup.module.scss';

export interface RadioOption<T> {
    value: T;
    inlineLabel?: string;
    description?: string;
}

interface RadioGroupProps<T> {
    value: T;
    label?: string;
    error?: string;
    className?: string;
    options: RadioOption<T>[];
    onChange?: (value: T) => void;
}

export const RadioGroup = <T,>(props: RadioGroupProps<T>) => {
    return (
        <div className={styles.root}>
            {props.label && <Label error={props.error}>{props.label}</Label>}

            <div className={clsx(styles.optionsContainer, props.className)}>
                {props.options.map((option, index) => (
                    <Radio
                        key={option.inlineLabel || index}
                        inlineLabel={option.inlineLabel}
                        description={option.description}
                        checked={props.value === option.value}
                        onChange={() => props.onChange?.(option.value)}
                    />
                ))}
            </div>
        </div>
    );
};

export default RadioGroup;
